import { IonAlert } from "@ionic/react";
import React, { useContext } from "react";
import { AppContext } from "../../context/app.context";
import { getPHQById, restoreSnapshot, restoreVersion, searchPages } from "../../misc/phqHTTP";
import { HttpStatusCodeEnum } from "../../models/http-status-code.enum";
import { PHQVersion, SnapShot } from "../../models/questionnaire.model";
import { QuestionnaireActionTypes } from "../../reducers/questionnaire.reducer";

const PHQRestoreAlert = (props: { fnCloseModal: (result: boolean) => void, version: PHQVersion | undefined, snapShot: SnapShot | undefined, isOpen: boolean }) => {

    const appContext = useContext(AppContext);

    const restoreVersionCallBack = async (version: PHQVersion) => {
        const res = await restoreVersion(version.PHQVersionID);

        if (res.status === HttpStatusCodeEnum.OK) {
            await handleUpdate(version.PHQID, "Version Restored");
        }
        props.fnCloseModal(true);
    }

    const restoreSnapShotCallBack = async (snapshot: SnapShot) => {
        const result = await restoreSnapshot(snapshot.SnapshotID);
        const version = (appContext.questionnaire.PhqSelected.Versions || []).find(v => v.IsCurrent);

        if (result.status === HttpStatusCodeEnum.OK) {
            await handleUpdate(version?.PHQID!, "Snapshot Restored");
        }
        props.fnCloseModal(true);
    }

    const handleUpdate = async (PHQID: number, message: string) => {
        const phqResponse = await getPHQById(PHQID);
            const pagesResponse = await searchPages({ PHQID });
            const phq = phqResponse.data.result;
            phq.Pages = pagesResponse.data.result;
            appContext.updateQuestionnaire(QuestionnaireActionTypes.RESTORE_PHQ, phq);
            appContext.notifySuccess(message);
    }

    return (
        <React.Fragment>
            <IonAlert
                isOpen={props.isOpen}
                onDidDismiss={() => props.fnCloseModal(false)}
                cssClass='my-custom-class'
                header={'Confirm'}
                message={'Are you sure you want to restore ?'}
                buttons={[
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        // handler: () => {
                        //     props.fnCloseModal(false)
                        // }
                    },
                    {
                        text: 'Yes',
                        handler: () => {
                            props.snapShot && restoreSnapShotCallBack(props.snapShot)
                            props.version && restoreVersionCallBack(props.version);
                        }
                    }
                ]}
            />
        </React.Fragment>
    )
}

export default PHQRestoreAlert